<div class="setting-search" style="position: relative;">

    <div class="camera" (click)="upload.click()">
        <img [src]="domSanitizer.bypassSecurityTrustUrl(previewURL)" alt="">
        <input type="file" hidden accept="image/jpg,image/png" (change)="fileChange($event)" #upload>
    </div>
    <div class="save">
        <button mat-raised-button class="rubii-btn" color="primary" (click)="save()">Save</button>
    </div>
</div>